<div class="container-fluid mt-3">
  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>

  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="mb-0">Drip Campaign Templates</h4>
    <button pButton type="button" label="+ New Template" icon="pi pi-plus"
            class="p-button-primary" (click)="onNew()"></button>
  </div>

  <p-table [value]="templates"
           [lazy]="true"
           (onLazyLoad)="loadLazy($event)"
           [paginator]="true"
           [rows]="50"
           [totalRecords]="recordTotal"
           [loading]="loading"
           [sortMode]="'multiple'"
           [multiSortMeta]="multiSortMeta"
           dataKey="dripCampaignTemplateId"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
           responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name" style="min-width:200px">Name <p-sortIcon field="name"></p-sortIcon></th>
        <th style="min-width:250px">Description</th>
        <th style="width:130px">Task Source</th>
        <th style="width:80px">Active</th>
        <th style="width:100px">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-t>
      <tr>
        <td>{{t.name}}</td>
        <td>
          <span [title]="t.description">
            {{t.description ? (t.description.length > 60 ? (t.description | slice:0:60) + '...' : t.description) : ''}}
          </span>
        </td>
        <td>
          <span class="badge badge-info">{{getTaskSourceLabel(t.applicableTaskSource)}}</span>
        </td>
        <td>
          <span *ngIf="t.active" class="badge badge-success">Active</span>
          <span *ngIf="!t.active" class="badge badge-secondary">Inactive</span>
        </td>
        <td>
          <button pButton type="button" icon="pi pi-pencil" class="p-button-sm p-button-text"
                  title="Edit" (click)="onEdit(t)"></button>
          <button pButton type="button" icon="pi pi-trash" class="p-button-sm p-button-text p-button-danger"
                  title="Delete" (click)="onDelete(t)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td colspan="5" class="text-center p-4">No templates found.</td></tr>
    </ng-template>
  </p-table>
</div>
